import { hapticFeedback } from "./hapticFeedback";

export const flashResetOverlay = () => {
    //@ts-ignore
    window.reset_overlay.classList.add('active');
    hapticFeedback();
    
    setTimeout(() => {
        //@ts-ignore
        window.reset_overlay.classList.remove('active');
    }, 500);
}